export default __webpack_public_path__ + "static/typescript-af108db04a54d784da9bf75244a6daf5.png";